import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { useDecisionMakerProfilePageData } from 'src/app/pages/decisionMakerProfile/pageContext';
import { useCountryCode } from 'src/app/shared/hooks/l10n';
import { useTrackView } from 'src/app/shared/hooks/tracking';
import { getUsState } from 'src/app/shared/utils/unitedStatesMapping';

type Result = ModelHookResult<
	{
		displayName: string;
		id: string;
		neighborhoodCheckText: string;
	},
	{
		trackSapClick: () => void;
	}
>;

export function useSapToDm(): Result {
	const { displayName, district, id, state } = useDecisionMakerProfilePageData();
	const country = useCountryCode();
	const track = useTracking();

	let neighborhoodCheckText = '';
	if (country === 'US' && (state || district)) {
		let formattedDistrict = '';
		if (district && /\d/.test(district)) {
			formattedDistrict = `District ${district}`;
		} else if (district) {
			formattedDistrict = district;
		}
		const formattedState = state ? getUsState(state) : '';
		neighborhoodCheckText = `${`Do you live in ${formattedDistrict} ${formattedState}`.replace(/\s+/g, ' ').trim()}? `;
	}

	const trackSapClick = useCallback(() => {
		void track('dm_profile_sap_click', { source_location: 'sap_container' });
	}, [track]);

	useTrackView('dm_profile_redesign_sap_view');

	return {
		data: {
			displayName,
			id,
			neighborhoodCheckText,
		},
		actions: {
			trackSapClick,
		},
	};
}
